import { jsx as _jsx } from "react/jsx-runtime";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography/Typography";
import { LandingPageStatusesResource } from "@ploy-lib/rest-resources";
import { useStatefulResource } from "@rest-hooks/legacy";
import { useSnackbar } from "notistack";
import { Suspense } from "react";
import { defineMessages, FormattedDate, FormattedMessage, useIntl } from "react-intl";
import { useFetcher } from "rest-hooks";
import { DployTable } from "../DployTable";
export const landingPageStatusMessages = defineMessages({
    statusvalue: {
        id: "dploy.kyc-landing-page-status.status.value",
        defaultMessage: `{status, select,
			MissingContactInfo {Mangler kontaktinformasjon}
			NotSent {Ikke sendt}
			Sent {Sendt landingsside til kunde}
			Completed {Fullført landingsside}
			Reused {Gjenbrukt besvarelser}
			SentOtherApp {Sendt link på annen sak}
		}`
    },
    customerLabel: {
        id: "dploy.kyc-landing-page-status.customer.label",
        defaultMessage: "Kunde / kontaktperson"
    },
    dateLabel: {
        id: "dploy.kyc-landing-page-status.date.label",
        defaultMessage: "Dato"
    },
    statusLabel: {
        id: "dploy.kyc-landing-page-status.status.label",
        defaultMessage: "Status"
    }
});
export function KycLandingPageStatus(props) {
    const { applicationId, className, externalPostback } = props;
    const { data: statuses } = useStatefulResource(LandingPageStatusesResource.list(), {
        applicationId
    });
    const intl = useIntl();
    const { enqueueSnackbar } = useSnackbar();
    const distribute = useFetcher(LandingPageStatusesResource.distribute());
    return (_jsx("div", { className: className, children: _jsx(Grid, { container: true, spacing: 2, children: _jsx(Grid, { item: true, xs: 12, md: 12, children: _jsx(Suspense, { fallback: _jsx(LinearProgress, {}), children: _jsx(DployTable, { title: _jsx(Typography, { variant: "h6", children: _jsx(FormattedMessage, { id: "dploy.kyc-landing-page-status.title", defaultMessage: "Kundeerkl\u00E6ring" }) }), columns: [
                            {
                                title: intl.formatMessage(landingPageStatusMessages.customerLabel),
                                field: "customerName"
                            },
                            {
                                title: intl.formatMessage(landingPageStatusMessages.statusLabel),
                                field: "status",
                                render: data => {
                                    return (_jsx(FormattedMessage, { ...landingPageStatusMessages.statusvalue, values: {
                                            status: data.status
                                        } }));
                                }
                            },
                            {
                                title: "Dato",
                                field: "changedDate",
                                render: data => {
                                    return (_jsx(FormattedDate, { value: data.changedDate, format: "long_datetime" }));
                                }
                            }
                        ], data: statuses || [], actions: [
                            {
                                icon: "",
                                tooltip: "",
                                onClick: async (e, data) => {
                                    try {
                                        await distribute(null, {
                                            shortRef: data.shortReference
                                        });
                                        enqueueSnackbar(_jsx(Typography, { children: _jsx(FormattedMessage, { id: "dploy.kyc-landing-page-status.success.label", defaultMessage: "Sendte ny landingsside" }) }), {
                                            variant: "success"
                                        });
                                        externalPostback();
                                    }
                                    catch (error) {
                                        enqueueSnackbar(_jsx(Typography, { children: _jsx(FormattedMessage, { id: "dploy.kyc-landing-page-status.error.label", defaultMessage: "Noe gikk galt ved distribuering av ny landingsside" }) }), {
                                            variant: "error"
                                        });
                                    }
                                }
                            }
                        ], options: {
                            actionsColumnIndex: -1,
                            search: false,
                            draggable: false,
                            sorting: false,
                            paging: statuses != null && statuses.length > 5,
                            showEmptyDataSourceMessage: false,
                            header: true
                        }, components: {
                            Action: ({ data, action }) => {
                                if (!data.canSendNewLink)
                                    return null;
                                return (_jsx(Button, { onClick: event => action.onClick(event, data), size: "large", color: "primary", variant: "text", children: _jsx(FormattedMessage, { id: "dploy.kyc-landing-page.new-landing-page.label", defaultMessage: "Send ny landingsside" }) }));
                            }
                        } }) }) }) }) }));
}
KycLandingPageStatus.displayName = "DployKycLandingPageStatus";
//# sourceMappingURL=KycLandingPageStatuses.js.map